window.initBorderGradientAnimation = function initBorderGradientAnimation() {
  if(window.borderGradientDocs) return; 
  window.borderGradientDocs = true;

  // --- КОНФИГУРАЦИЯ ---
  const CONFIG = {
    rotationSpeed: 0.5,
    friction: 0.92,
    stopThreshold: 0.1,
    quality: 1,
  };

  const borderGradientElsArr = document.querySelectorAll('[data-border-gradient-card]');
  if (borderGradientElsArr.length === 0) return;

  // --- INTERSECTION OBSERVER ---
  const observerOptions = { rootMargin: '100px 0px', threshold: 0.01 };
  const visibilityMap = new WeakMap();

  const visibilityObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      visibilityMap.set(entry.target, entry.isIntersecting);
      if (entry.isIntersecting && !entry.target.isAnimating) {
        entry.target.attemptInitialDraw();
      }
    });
  }, observerOptions);

  // --- ИНИЦИАЛИЗАЦИЯ КАЖДОЙ КАРТОЧКИ ---
  borderGradientElsArr.forEach((borderGradientEl) => {
    if(borderGradientEl.dataset.bgAnimInit) return;
    borderGradientEl.dataset.bgAnimInit = 'true';

    const bgElement = borderGradientEl.querySelector('[data-border-gradient-card-bg]');
    if (!bgElement) return;

    const sourceImgEl = bgElement.querySelector('img');
    if (!sourceImgEl) return;

    if (getComputedStyle(borderGradientEl).position === 'static') {
      borderGradientEl.style.position = 'relative';
    }
    borderGradientEl.style.overflow = 'hidden';

    const canvas = document.createElement('canvas');
    canvas.style.position = 'absolute';
    canvas.style.inset = '0';
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.pointerEvents = 'none';
    canvas.style.zIndex = '1';

    bgElement.appendChild(canvas)

    visibilityObserver.observe(borderGradientEl);
    visibilityMap.set(borderGradientEl, false);

    const ctx = canvas.getContext('2d', { alpha: false });

    let img = sourceImgEl;
    let currentAngle = 0;
    let isHovering = false;
    let isAnimating = false;

    Object.defineProperty(borderGradientEl, 'isAnimating', {
      get: () => isAnimating
    });

    let width = 0;
    let height = 0;
    let diagonal = 0;
    let imageLoaded = img.complete;

    function updateCanvasSize() {
      const rect = borderGradientEl.getBoundingClientRect();
      const dpr = window.devicePixelRatio || 1;

      if (rect.width === 0 || rect.height === 0) return false;

      const newWidth = rect.width * dpr * CONFIG.quality;
      const newHeight = rect.height * dpr * CONFIG.quality;

      // Проверяем, изменился ли размер фактически
      if (canvas.width !== newWidth || canvas.height !== newHeight) {
        width = newWidth;
        height = newHeight;
        canvas.width = width;
        canvas.height = height;
        diagonal = Math.sqrt(width * width + height * height);

        // ВАЖНО: Сбрасываем трансформацию сразу после ресайза, так как контекст очистился
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        return true; // Размер изменился
      }

      ctx.setTransform(1, 0, 0, 1, 0, 0);
      return false; // Размер не менялся, но он валиден (или true, если хотим форсировать перерисовку, но false лучше для оптимизации)
    }

    function draw() {
      if (!imageLoaded || width === 0) return;

      // Очистка не обязательна, если мы рисуем поверх всего 'cover' изображением,
      // но для надежности оставим, или если картинка с прозрачностью.
      // При изменении размера канвас и так чист.
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, width, height);

      const scale = Math.max(diagonal / img.naturalWidth, diagonal / img.naturalHeight);
      const drawWidth = img.naturalWidth * scale;
      const drawHeight = img.naturalHeight * scale;

      ctx.translate(width / 2, height / 2);
      ctx.rotate(currentAngle * Math.PI / 180);
      ctx.drawImage(img, -drawWidth / 2, -drawHeight / 2, drawWidth, drawHeight);
    }

    function attemptInitialDraw() {
      if (!imageLoaded) return;

      // 1. Обновляем размеры
      // updateCanvasSize теперь возвращает true только если размер реально поменялся
      // Но нам нужно рисовать в любом случае при вызове attemptInitialDraw
      const sizeValid = updateCanvasSize() || (width > 0 && height > 0);

      // 2. ИСПРАВЛЕНИЕ: Рисуем СИНХРОННО, без requestAnimationFrame
      // Это предотвращает мигание (черный экран) при ресайзе
      if (sizeValid) {
        draw();
      }
    }

    borderGradientEl.attemptInitialDraw = attemptInitialDraw;

    function animate() {
      const isVisible = visibilityMap.get(borderGradientEl);

      if (!isVisible && !isHovering) {
        isAnimating = false;
        return;
      }

      let needsRedraw = false;

      if (isHovering) {
        currentAngle += CONFIG.rotationSpeed;
        needsRedraw = true;
      } else {
        if (Math.abs(currentAngle) > CONFIG.stopThreshold) {
          currentAngle *= CONFIG.friction;
          needsRedraw = true;
        } else {
          currentAngle = 0;
        }
      }

      if (currentAngle > 360) currentAngle -= 360;
      else if (currentAngle < -360) currentAngle += 360;

      if (isVisible && needsRedraw) {
        draw();
      }

      if (isHovering || Math.abs(currentAngle) > CONFIG.stopThreshold) {
        requestAnimationFrame(animate);
      } else {
        isAnimating = false;
        if (isVisible) draw();
      }
    }

    // --- ЛОГИКА ИНИЦИАЛИЗАЦИИ ---
    if (!imageLoaded) {
      img.onload = () => {
        imageLoaded = true;
        attemptInitialDraw();
        img.onload = null;
      };
      img.onerror = () => { img.onerror = null; };
    }
    attemptInitialDraw();

    // --- ОБРАБОТЧИКИ ---
    borderGradientEl.addEventListener('mouseenter', () => {
      isHovering = true;
      attemptInitialDraw();
      if (!isAnimating) {
        isAnimating = true;
        animate();
      }
    });

    borderGradientEl.addEventListener('mouseleave', () => {
      isHovering = false;
    });

    // ИСПРАВЛЕНИЕ: ResizeObserver без лишних вложенных requestAnimationFrame
    const resizeObserver = new ResizeObserver(() => {
      // Вызываем напрямую. ResizeObserver срабатывает перед paint,
      // поэтому синхронный draw() успеет нарисовать картинку до того, как браузер покажет кадр.
      attemptInitialDraw();

      if (img.complete && !isAnimating && visibilityMap.get(borderGradientEl)) {
        draw();
      }
    });
    resizeObserver.observe(borderGradientEl);
  });
};

if(window.innerWidth > 1024) {
  window.initBorderGradientAnimation();
}